import { render, staticRenderFns } from "./LocationsControl.vue?vue&type=template&id=5c939888&scoped=true&"
import script from "./LocationsControl.vue?vue&type=script&lang=js&"
export * from "./LocationsControl.vue?vue&type=script&lang=js&"
import style0 from "./LocationsControl.vue?vue&type=style&index=0&id=5c939888&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c939888",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c939888')) {
      api.createRecord('5c939888', component.options)
    } else {
      api.reload('5c939888', component.options)
    }
    module.hot.accept("./LocationsControl.vue?vue&type=template&id=5c939888&scoped=true&", function () {
      api.rerender('5c939888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/device_controls/LocationsControl.vue"
export default component.exports